export default __webpack_public_path__ + "static/media/Ela-e-o-Violo.319d6314.jpg";